<template>
  <div>
    <el-dialog style="border-radius: 8px;" :show-close="false" top="calc((100vh - 500px)/2)" :visible="value" width="693px" :before-close="handleClose">
      <div class="content_box">
        <div class="header">
          <div class="left_header">
            <div class="title">兼职时间</div>
          </div>
          <div class="right_header">
            <i class="el-icon-close" @click="handleClose"></i>
          </div>
        </div>
        <div class="contet">
          <div class="row_item" v-for="item in  TimeData" :key="item.name">
            <div class="label">{{ item.name }} :</div>
            <div class="select_box">
              <el-radio-group v-if="item.name !=='工作时间'" v-model="item.value">
                <div v-for="itemC in item.option" :key="itemC.label">
                  <div v-if="item.value =='自定义' && itemC.label =='自定义'" class="select_date">
                    <el-date-picker popper-class="date-style" value-format="yyyy-MM-dd" v-model="item.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </div>
                  <el-radio-button v-else :key="itemC.label" :label="itemC.label"></el-radio-button>
                </div>
              </el-radio-group>
              <el-radio-group v-else v-model="item.value">
                <el-radio v-for="itemC in item.option" :key="itemC.value" :label="itemC.value">{{ itemC.label }}</el-radio>
              </el-radio-group>
              <div class="select_work_time" v-if="item.name=='工作时间'">
                <!-- <PartTimePicker v-if="item.value==1" /> -->
                <el-time-picker v-if="item.value==1" is-range v-model="item.date" step="00:15:00" format="HH:mm" value-format="HH:mm" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                  :use-24-hour="true" :picker-options="{
      selectableRange: '00:00-23:59',

      }"></el-time-picker>
                <el-radio-group v-if="item.value==2" v-model="item.date">
                  <el-radio-button v-for="time in work_time" :key="time" :label="time"></el-radio-button>
                </el-radio-group>
              </div>
            </div>

          </div>
        </div>
        <div class="footer_box">
          <el-button class="button" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import zymc from "@/utils/zymc.json";
import PartTimePicker from "./PartTimePicker.vue";
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      require: true,
    },

    part_time_hours: {
      type: Object,
    },
  },
  components: {
    PartTimePicker,
  },
  watch: {
    part_time_hours: {
      handler(newVal) {
        if (this.part_time_hours.workdays_per_week) {
          // 每周工作天数
          this.TimeData[2].value = this.part_time_hours.workdays_per_week;
        }

        if (this.part_time_hours.working_dates) {
          // 工作日期
          if (
            ["1个月", "2个月", "3个月", "6个月", "长期兼职"].includes(
              this.part_time_hours.working_dates
            )
          ) {
            this.TimeData[0].value = this.part_time_hours.working_dates;
          } else {
            this.TimeData[0].value = "自定义";
            const parts = this.part_time_hours.working_dates.split("-");
            const firstDateStr = `${parts[0]}-${parts[1]}-${parts[2]}`;
            const secondDateStr = `${parts[3]}-${parts[4]}-${parts[5]}`;
            this.TimeData[0].date = [firstDateStr, secondDateStr];
          }
        }
        if (this.part_time_hours.working_hours) {
          // 工作时间
          this.TimeData[3].value = this.part_time_hours.working_hours.type;
          this.TimeData[3].date = this.part_time_hours.working_hours.time;
        }
        if (this.part_time_hours.working_time_period) {
          //工作时间段
          this.TimeData[1].value = this.part_time_hours.working_time_period;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      TimeData: [
        {
          name: "工作日期",
          option: [
            {
              label: "1个月",
            },
            {
              label: "2个月",
            },
            {
              label: "3个月",
            },
            {
              label: "6个月",
            },
            {
              label: "长期兼职",
            },
            {
              label: "自定义",
            },
          ],
          value: "",
          date: [],
        },
        {
          name: "工作时间段",
          option: [
            {
              label: "工作日",
            },
            {
              label: "周末节假日",
            },
            {
              label: "全周轮班",
            },
            {
              label: "按单安排时间",
            },
            {
              label: "不限时间",
            },
          ],
          value: "不限时间",
        },
        {
          name: "每周工作天数",
          option: [
            {
              label: "五天及以上",
            },
            {
              label: "3-4天",
            },
            {
              label: "2-3天",
            },
            {
              label: "1-2天",
            },
            {
              label: "无要求",
            },
          ],
          value: "",
        },
        {
          name: "工作时间",
          option: [
            {
              label: "自定义",
              value: 1,
            },
            {
              label: "按班次",
              value: 2,
            },
            {
              label: "不限时间",
              value: 3,
            },
          ],
          value: 3,
          date: "",
        },
      ],
      work_time: ["早班", "午班", "晚班", "夜班"],
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setDate(date.getDate() - 1);
          console.log(time.getTime() < date.getTime());
          return time.getTime() < date.getTime();
        },
      },
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
    confirm() {
      for (let i = 0; i < this.TimeData.length; i++) {
        if (this.TimeData[i].name == "工作日期") {
          if (this.TimeData[i].value == "自定义") {
            if (this.TimeData[i].date.length == 0) {
              this.$message.warning("请输入工作日期");
              return;
            }
          }
        }
        if (this.TimeData[i].name == "工作时间") {
          if (this.TimeData[i].value == 3) {
            if (this.TimeData[i].date == "") {
              this.$message.warning("工作时间不能为空");
              return;
            }
          }
        }
        if (!this.TimeData[i].value) {
          this.$message.warning(`请选择${this.TimeData[i].name}`);
          return;
        }
        let obj = {
          working_dates:
            this.TimeData[0].value == "自定义"
              ? this.TimeData[0].date.join("-")
              : this.TimeData[0].value,
          working_time_period: this.TimeData[1].value,
          workdays_per_week: this.TimeData[2].value,
          working_hours: {
            type: this.TimeData[3].value,
            time: this.TimeData[3].date,
          },
        };
        this.$emit("getPartTime", obj);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content_box {
  width: 100%;
  // height: 528px;
  background: #fff;
  box-sizing: border-box;
  padding: 30px 30px 24px 30px;
  border-radius: 8px !important;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: linear-gradient(180deg, #f6f5ff 0%, #fbfcff 23%);
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .left_header {
      .title {
        font-size: 20px;
        font-weight: 500;
        color: #444444;
        line-height: 20px;
        margin-bottom: 10px;
      }
      .tip {
        font-size: 14px;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
        margin-bottom: 24px;
      }
    }

    .right_header {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .contet {
    width: 100%;
    box-sizing: border-box;
    .row_item {
      display: flex;
      .label {
        flex-shrink: 0;
        width: 110px;
        color: #8d97a6;
        line-height: 20px;
        align-items: flex-start;
        margin-top: 7px;
        font-size: 16px !important;
      }
      .select_box {
        flex: 1;
        flex-shrink: 0;
        .select_work_time {
          margin-top: 10px;
        }
      }
    }
  }
  .footer_box {
    width: 100%;

    display: flex;
    justify-content: flex-end;
    .button {
      width: 88px;
      height: 38px;
      background: #685ef5;
      border-radius: 4px 4px 4px 4px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      margin: 22px 0;
    }
  }
}
.el-radio-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .el-radio-button {
    margin-right: 12px;
    margin-bottom: 13px;

    ::v-deep .el-radio-button__inner {
      width: 116px;
      border: 1px solid #e6e8eb;
      border-radius: 4px 4px 4px 4px;
      font-weight: 500;
      font-size: 14px;
      color: #363e4d;
      box-shadow: none;
      padding: 7px 0;
      line-height: 20px;
    }
  }
  .el-radio-button.is-checked {
    background: #e9e8ff;
    ::v-deep .el-radio-button__inner {
      border: 1px solid #685ef5;
      color: #685ef5;
      background: #e9e8ff;
      box-shadow: none;
      position: relative;
    }
  }
  .el-radio {
    height: 37px !important;
    display: flex;
    align-items: center;
    ::v-deep .el-radio__input {
      width: 16px;
      height: 16px;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: rgba(255, 255, 255, 0.9);
      border-color: #685ef5 !important;
      &::after {
        width: 8px;
        height: 8px;
        background: #685ef5 !important;
      }
    }
  }
  .select_date {
    margin-right: 12px;
    margin-bottom: 13px;

    ::v-deep .el-input__inner {
      height: 36px !important;
    }
  }
}

.searchItem {
  display: inline-block;
  margin: 10px 0;
  margin-right: 12px;

  .searchLabel {
    font-size: 14px;
    color: #333;
  }

  .itemInput {
    display: inline-block;
    width: 200px;
    margin-left: 8px;

    &.longInput {
      // width: 320px;
    }
  }
}

.icon_show {
  border-radius: 1px;
  border: 1px solid #00c2b3;
  box-sizing: border-box;
  text-align: center;
  line-height: 14px;
  font-size: 12px;
  color: #00c2b3;
  vertical-align: middle;
  margin-left: 4px;
  font-weight: 400;
}
::v-deep .el-radio.is-bordered.is-checked {
  border-color: #dcdfe6 !important;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #00a6a7 !important;
  background: #00a6a7;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #414a75;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
  border-radius: 8px !important;
}

::v-deep .el-dialog {
  border-radius: 8px !important;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
::v-deep .el-scrollbar__bar .is-horizontal {
  display: none;
}
</style>
<style lang="scss">
</style>
